import { JetView } from "webix-jet";

export default class HiddenView extends JetView {
	config() {
		return {
			hidden: true,
		};
	}
}
